// extracted by mini-css-extract-plugin
module.exports = {"helpingText":"helpingText_helpingText__K9QNV"};